/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { InteractiveComponents } from '../../../core/enums';
import { RootState, useTivoSelector } from '../../../core/tivo/tivo-redux-wrapper';
import { Caret } from '../../common';

import './InteractiveLayer.scss';

const InteractiveLayer: FunctionComponent = (): JSX.Element => {
    const activeComponent = useTivoSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );
    const isCaretVisible = useTivoSelector((state: RootState) => state.gridGuide.isCaretVisible);
    const { LIMIT, channelsCount } = useTivoSelector((state: RootState) => state.gridGuide);

    return (
        <React.Fragment>
            <Caret
                direction={InteractiveComponents.EAST}
                visible={isCaretVisible && activeComponent === InteractiveComponents.EAST}
                active={activeComponent === InteractiveComponents.EAST}
                className="guide-east"
            />

            <Caret
                direction={InteractiveComponents.WEST}
                visible={isCaretVisible && activeComponent === InteractiveComponents.WEST}
                active={activeComponent === InteractiveComponents.WEST}
                className="guide-west"
            />

            <Caret
                direction={InteractiveComponents.NORTH}
                visible={
                    isCaretVisible &&
                    activeComponent === InteractiveComponents.NORTH &&
                    (!channelsCount || channelsCount > LIMIT)
                }
                active={activeComponent === InteractiveComponents.NORTH}
                className="guide-north"
            />

            <Caret
                direction={InteractiveComponents.SOUTH}
                visible={
                    isCaretVisible &&
                    activeComponent === InteractiveComponents.SOUTH &&
                    (!channelsCount || channelsCount > LIMIT)
                }
                active={activeComponent === InteractiveComponents.SOUTH}
                className="guide-south"
            />
        </React.Fragment>
    );
};

export default InteractiveLayer;
